import {GlobalBanner} from './components/GlobalBanner/GlobalBanner'
import {getActiveBanner} from './utils/get-active-banner'
import type {MarketingGlobalBannerProps} from './marketing-global-banner.types'

/**
 * Dismissal is handled by the existing dotcom Catalyst controller + blocking-hide script at/before
 * hydration (not in React), so SSR output stays deterministic. The trailing `<active-global-banners>`
 * element drives that controller's dismissal-cookie garbage collection.
 */
export function MarketingGlobalBanner(props: MarketingGlobalBannerProps) {
  const {current_path, is_staff, locale} = props

  const banner = getActiveBanner({current_path, is_staff, locale})

  if (!banner) return null

  return (
    <>
      <GlobalBanner banner={banner} />
      <active-global-banners data-banners={banner.uid} />
    </>
  )
}
